import gsap from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export class Translation {
  constructor() {
    this._els = document.querySelectorAll('[appear-translation]');
    let page = document.querySelector('.faire-un-don');

    if (this._els.length && !page) {
      this.init()
    }
  }

  init() {
    this._els.forEach((el) => {
      let type = el.getAttribute('appear-type') ?? null;

      if (type === 'image') {
        el = el.querySelector('img');
      }


      let tl = gsap.timeline({
        scrollTrigger: {
          trigger: el,
          start: 'top bottom-=5%',
          end: 'bottom bottom-=20%',
          toggleActions: 'play none none reverse',
          scrub: 1
        }
      })

      if (type === 'image') {
        tl.fromTo(el,
          {
            scale: 1.05
          },
          {
            scale: 1,
          }
        )
      } else {
        tl.fromTo(el,
          {
            opacity: 0.2,
            y: -50,
          },
          {
            opacity: 1,
            y: 0,
          }
        )
      }

    });
  }
}
